import { w3Api } from '../w3Api'

export const BannerEndpoints = {
  getBanner: (key: string) => `/banner/${key}`,
}

const BannerApi = w3Api.injectEndpoints({
  endpoints: (build) => ({
    getBanner: build.query<any, Record<string, string>>({
      query: ({ key, ...args }) => {
        return {
          url: `${BannerEndpoints.getBanner(String(key))}`,
          params: args,
        }
      },
    }),
  }),
})

export const { useGetBannerQuery } = BannerApi
